import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../config/axios';
// import { BASE_URL } from '../config/axios';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import * as XLSX from 'xlsx';
import { Modal } from 'react-bootstrap';
import { DownloadTableExcel } from 'react-export-table-to-excel';

import { formatCurrencyIndian, getMonthName, handleErrorToast, sortProjects, inputMaxLimit, isMoreThan24Hours, CSSForSelect23vWWidth, CSSForSelect, Addbutton, ProgressModal, CSSForSelect15vWWidth, CSSForSelectModern } from '../CustomFunctions';
import { DateRangePicker } from '../../components/CustomFunctions';

import { AddwithWhiteCircle, Calender, CircularGrid, DeleteDustbin, DropdownArrow, Location, UpdatePencil, HourGlass, Filter, SearchBig, AddwithBlueCircle, DropdownArrowOption, SubCompany, DownloadIcon, UploadIcon, Attachment, Refresh } from '../AllSvg';
// import { DeleteSiteEmployee, UpdateSiteEmployee } from './Wfm/WorkforceCrudButton';
import usePermission from '../../config/permissions';
import { Projects, SubCompanyModern } from '../FilterDropdown';
// import usePermission from '../config/permissions';
import Select, { components } from "react-select";

// import { Projects } from './FilterDropdown';
import { UploadOfficeRentBulk } from '../SiteManagement/BulkModals';
// import { UploadOfficeRentBulk } from './SiteManagement/BulkModals';
import { DocumentModel } from '../SiteManagement/ProjectDetailsCrudButtons';
import { AlertCircle, Briefcase, Building2, Calendar, ChevronDown, ChevronRight, ChevronUp, Clock, CreditCard, FileText, Hash, Home, IndianRupee, Landmark, Loader, MapPin, Phone, Save, SearchCheck, Sparkles, Trash2, User, X } from 'lucide-react';
import { AddDynamicButton } from '../SiteManagement/Components/modernbuttons/AddDynamicButton';

const AddOfficeRent = ({ getRent, siteProjectList, subcompanyId }) => {
  const [show, setShow] = useState(false);
  const projectID = sessionStorage.getItem("sitemanagement_project_site_prcode");
  const [activeSection, setActiveSection] = useState('office');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'office', label: 'Office & Project', icon: Building2 },
    { id: 'financials', label: 'Financials', icon: IndianRupee },
    { id: 'timeline', label: 'Agreement Timeline', icon: Calendar },
    { id: 'bank', label: 'Bank & Contact', icon: CreditCard },
  ];

  const tabRequiredFields = {
    office: ["project", "office_type", "BOQOfficeRent"],
    financials: ["rent_amt"],
    timeline: ["agreement_duration", "agreement_date", "end_date"],
    bank: ["owner_name", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "gst_num", "address", "mobile"],
  };

  const initialFormData = {
    project: projectID ? projectID : "null",
    rent_amt: "",
    agreement_duration: "",
    agreement_date: "",
    end_date: null,
    owner_name: "",
    bank_name: "",
    account_holder_name: "",
    account_num: "",
    ifsc_code: "",
    pan_card: "",
    gst_num: "",
    address: "",
    aggrement_extension_duration: "0",
    office_type: "",
    mobile: "",
    BOQOfficeRent: '',
    total_amt: "",
  };

  const handleClose = () => {
    setFormData(initialFormData);
    setErrors({});
    setTabValidationAttempted({});
    setActiveSection('office');
    setShow(false);
  };

  const [project, setProject] = useState(projectID ? projectID : "null");
  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [boqList, setBoqList] = useState([]);
  const [loadingboq, setLoadingboq] = useState(false);

  const getBoq = async () => {
    try {
      const ress = await axios.get(`${BASE_URL}/siteproject/boqofficerentfilters/${formData.project}/`);
      setBoqList(ress.data);
      setLoadingboq(true);
    } catch (err) { }
  };

  const handleShow = () => {
    setShow(true);
    getproject();
    setErrors({});
    setTabValidationAttempted({});
    setActiveSection('office');
  };

  useEffect(() => {
    setFormData((prev) => ({ ...prev, project: project }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  }, [project]);

  useEffect(() => {
    if (formData.project != "") getBoq();
  }, [formData.project]);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["project", "rent_amt", 'office_type', "agreement_duration", "agreement_date", "owner_name", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "gst_num", "address", "mobile", "end_date"];
    if (formData.office_type === "Site Office" && !formData.BOQOfficeRent) {
      newErrors.BOQOfficeRent = "This is required field!";
    }
    if (formData.project === "null") {
      newErrors.project = "This is required field!";
    }
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });
    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const newErrors = {};
    let fieldsToValidate = [...(tabRequiredFields[currentTab] || [])];

    if (currentTab === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }

    fieldsToValidate.forEach((field) => {
      const value = field === "project" ? (formData.project === "null" ? "" : formData.project) : formData[field];
      if (!value) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors((prev) => {
      const updated = { ...prev, ...newErrors };
      fieldsToValidate.forEach((field) => {
        if (!(field in newErrors)) delete updated[field];
      });
      return updated;
    });

    setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  const hasCurrentTabErrors = () => {
    const currentTab = activeSection;
    const fieldsToValidate = tabRequiredFields[currentTab] || [];
    return fieldsToValidate.some((field) => errors[field]);
  };

  const getCurrentTabErrorMessage = () => {
    const currentTab = activeSection;
    let fieldsToValidate = [...(tabRequiredFields[currentTab] || [])];
    if (currentTab === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }
    const missingFields = fieldsToValidate
      .filter((field) => {
        const value = field === "project" ? (formData.project === "null" ? "" : formData.project) : formData[field];
        return !value;
      })
      .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

    if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
    if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
    if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
    return `Please fix the errors in this section before proceeding`;
  };

  const tabHasMissingFields = (tabId) => {
    let fieldsToValidate = [...(tabRequiredFields[tabId] || [])];
    if (tabId === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }
    return fieldsToValidate.some((field) => {
      const value = field === "project" ? (formData.project === "null" ? "" : formData.project) : formData[field];
      return !value;
    });
  };

  const [loading, setLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const getproject = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/project/`);
      const splitCodeParts = (code) => {
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/");
        const lastPart = parts.pop();
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
        if (match) {
          return { firstPart, numericPart: match[1] ? parseInt(match[1], 10) : 0, alphaPart: match[2] };
        }
        return { firstPart, numericPart: 0, alphaPart: "" };
      };
      const sortedList = response.data.sort((a, b) => {
        const aParts = splitCodeParts(a.site_prcode);
        const bParts = splitCodeParts(b.site_prcode);
        if (aParts.firstPart !== bParts.firstPart) return aParts.firstPart.localeCompare(bParts.firstPart);
        if (aParts.alphaPart !== bParts.alphaPart) return aParts.alphaPart.localeCompare(bParts.alphaPart);
        return aParts.numericPart - bParts.numericPart;
      });
      setProjectList(sortedList);
    } catch (error) {
      alert(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    const formDataa = new FormData();
    formDataa.append("project", formData.project);
    formDataa.append("rent_amt", formData.rent_amt);
    formDataa.append("agreement_duration", formData.agreement_duration);
    formDataa.append("agreement_date", formData.agreement_date);
    formDataa.append("office_type", formData.office_type);
    formDataa.append("aggrement_extension_duration", formData.aggrement_extension_duration);
    formDataa.append("owner_name", formData.owner_name);
    formDataa.append("bank_name", formData.bank_name);
    formDataa.append("account_holder_name", formData.account_holder_name);
    formDataa.append("account_num", formData.account_num);
    formDataa.append("ifsc_code", formData.ifsc_code);
    formDataa.append("pan_card", formData.pan_card);
    formDataa.append("gst_num", formData.gst_num);
    formDataa.append("address", formData.address);
    formDataa.append("mobile", formData.mobile);
    formDataa.append("total_amt", formData.total_amt);
    formDataa.append("BOQOfficeRent", formData.BOQOfficeRent);

    try {
      let res = await axios.post(`${BASE_URL}/siteproject/officerent/`, formDataa, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 200) {
        await getRent();
        toast.dismiss(loadingToastId);
        toast.success("Office rent added successfully!");
        handleClose();
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to add data!");
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const capitalizeFields = ["bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "gst_num"];
    const finalValue = capitalizeFields.includes(name) ? value.toUpperCase() : value;

    let updatedData = { ...formData, [name]: finalValue };

    if (name === "rent_amt") {
      const rentAmount = parseFloat(value).toFixed(2);
      const boqItem = boqList.find((attendance) => attendance.id === formData.BOQOfficeRent);

      if (boqItem) {
        const maxlimit = boqItem.rate_per_month;
        const { success, error } = inputMaxLimit(name, value, maxlimit);
        if (!success) {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
          return;
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
          if (rentAmount >= 50000) {
            const tdsPercentage = 10;
            const tdsAmount = parseFloat(((rentAmount * tdsPercentage) / 100).toFixed(2));
            updatedData = { ...updatedData, tds_percentage: tdsPercentage, tds_amt: tdsAmount, total_amt: parseFloat((parseFloat(rentAmount) - tdsAmount).toFixed(2)) };
          } else {
            updatedData = { ...updatedData, tds_percentage: "", tds_amt: 0, total_amt: parseFloat(rentAmount) };
          }
        }
      } else {
        if (rentAmount >= 50000) {
          const tdsPercentage = 10;
          const tdsAmount = parseFloat(((rentAmount * tdsPercentage) / 100).toFixed(2));
          updatedData = { ...updatedData, tds_percentage: tdsPercentage, tds_amt: tdsAmount, total_amt: parseFloat((parseFloat(rentAmount) - tdsAmount).toFixed(2)) };
        } else {
          updatedData = { ...updatedData, tds_percentage: "", tds_amt: 0, total_amt: parseFloat(rentAmount) };
        }
      }
    }

    if (name === "tds_percentage" && Number(formData.rent_amt) >= 50000) {
      const tdsPercentage = parseFloat(value).toFixed(2);
      const tdsAmount = parseFloat(((Number(formData.rent_amt) * tdsPercentage) / 100).toFixed(2));
      updatedData = { ...updatedData, tds_amt: tdsAmount, total_amt: parseFloat((Number(formData.rent_amt) - tdsAmount).toFixed(2)) };
    }

    setFormData(updatedData);
    setInputState({ ...inputState, [name]: finalValue.trim() ? "green" : "" });

    if (errors[name]) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const rentOption = [
    { value: "Site Office", label: "Site Office" },
    { value: "Guest House", label: "Guest House" },
  ];

  useEffect(() => {
    const { agreement_duration, aggrement_extension_duration, agreement_date } = formData;
    const durations = agreement_duration && aggrement_extension_duration ? Number(agreement_duration) + Number(aggrement_extension_duration) : "";
    const addMonthsToDate = (dateString, months) => {
      if (!dateString || !months) return "";
      const date = new Date(dateString);
      date.setMonth(date.getMonth() + Number(months));
      return date.toISOString().split("T")[0];
    };
    const endDate = addMonthsToDate(agreement_date, durations);
    setFormData((prev) => ({ ...prev, end_date: endDate }));
  }, [formData.agreement_date, formData.agreement_duration, formData.aggrement_extension_duration]);

  const handleTabSwitch = (targetTabId) => {
    if (activeSection === targetTabId) return;
    if (validateCurrentTab()) {
      setActiveSection(targetTabId);
      const modalBody = document.querySelector('.modern-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    } else {
      const modalBody = document.querySelector('.modern-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    }
  };

  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;
    if (!nextTab) return;
    handleTabSwitch(nextTab);
  };
  const goToPreviousTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
  };

  const renderOfficeSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Building2 size={18} />
        <h4>Office & Project</h4>
      </div>
      <div className="form-grid">
        {sessionStorage.getItem('sitemanagement_role') !== "SiteManagement" && (
          <div className="form-field">
            <Projects inputvalue="project" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subcompanyId} error={errors.project} SetErrors={setErrors} cssType="modern" />
            {errors.project && <span className="error-message">{errors.project}</span>}
          </div>
        )}

        <div className="form-field">
          <label><Home size={14} /> Office Type<span className="required">*</span></label>
          <Select
            options={rentOption}
            isSearchable isClearable
            placeholder="Select Office Type"
            value={rentOption.find((opt) => opt.value === formData.office_type)}
            onChange={(selectedOption) => {
              setFormData({ ...formData, office_type: selectedOption ? selectedOption.value : "" });
              setInputState({ ...inputState, office_type: selectedOption ? "green" : "" });
            }}
            styles={CSSForSelectModern}
          />
          {errors.office_type && <span className="error-message">{errors.office_type}</span>}
        </div>

        {(formData.project !== "null" && formData.office_type === "Site Office") && (
          <div className="form-field">
            <label><IndianRupee size={14} /> BOQ Rate<span className="required">*</span></label>
            {!loadingboq ? (
              <div className="loader-minimal" style={{ padding: '10px 0' }}>
                <div className="spinner-minimal"></div>
              </div>
            ) : (
              <select
                name="BOQOfficeRent"
                value={formData.BOQOfficeRent}
                onChange={handleInputChange}
                className={errors.BOQOfficeRent ? "error" : inputState.BOQOfficeRent ? "success" : ""}
              >
                <option value="">Select a Boq</option>
                {boqList?.sort((a, b) => a?.rate_per_month?.toString().localeCompare(b?.rate_per_month?.toString(), 'en', { ignorePunctuation: true })).map((b, index) => (
                  <option key={index} value={b.id}>₹{formatCurrencyIndian(b.rate_per_month)}</option>
                ))}
              </select>
            )}
            {errors.BOQOfficeRent && <span className="error-message">{errors.BOQOfficeRent}</span>}
          </div>
        )}
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Financials <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderFinancialsSection = () => (
    <div className="form-section">
      <div className="section-title">
        <IndianRupee size={18} />
        <h4>Financials</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><IndianRupee size={14} /> Basic Amount<span className="required">*</span></label>
          <input type="number" min={0} name="rent_amt" placeholder="80,000" onChange={handleInputChange} value={formData.rent_amt} className={errors.rent_amt ? "error" : inputState.rent_amt ? "success" : ""} />
          {errors.rent_amt && <span className="error-message">{errors.rent_amt}</span>}
        </div>

        {Number(formData.rent_amt) >= 50000 && (
          <>
            <div className="form-field">
              <label><IndianRupee size={14} /> TDS Percentage<span className="required">*</span></label>
              <input type="number" min={0} name="tds_percentage" placeholder="TDS Percentage" onChange={handleInputChange} value={formData.tds_percentage} className={errors.tds_percentage ? "error" : inputState.tds_percentage ? "success" : ""} />
              {errors.tds_percentage && <span className="error-message">{errors.tds_percentage}</span>}
            </div>
            <div className="form-field">
              <label><IndianRupee size={14} /> TDS Amount<span className="required">(Read Only)</span></label>
              <input type="number" min={0} name="tds_amt" placeholder="TDS Amount" value={formData.tds_amt} disabled readOnly className="readonly-field" />
            </div>
          </>
        )}

        <div className="form-field">
          <label><IndianRupee size={14} /> Total Amount<span className="required">(Auto Calculated)</span></label>
          <input type="number" min={0} name="total_amt" placeholder="80,000" value={formData.total_amt} disabled readOnly className="readonly-field" />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Agreement Timeline <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderTimelineSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Calendar size={18} />
        <h4>Agreement Timeline</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Clock size={14} /> Agreement Duration<span className="required">*</span></label>
          <input type="number" min={0} name="agreement_duration" placeholder="6 months" onChange={handleInputChange} value={formData.agreement_duration} className={errors.agreement_duration ? "error" : inputState.agreement_duration ? "success" : ""} />
          {errors.agreement_duration && <span className="error-message">{errors.agreement_duration}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement Date<span className="required">*</span></label>
          <input type="date" name="agreement_date" onChange={handleInputChange} value={formData.agreement_date} className={errors.agreement_date ? "error" : inputState.agreement_date ? "success" : ""} />
          {errors.agreement_date && <span className="error-message">{errors.agreement_date}</span>}
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Agreement Extension Duration</label>
          <input type="number" min={0} name="aggrement_extension_duration" placeholder="6 months" onChange={handleInputChange} value={formData.aggrement_extension_duration} className={errors.aggrement_extension_duration ? "error" : inputState.aggrement_extension_duration ? "success" : ""} />
          {errors.aggrement_extension_duration && <span className="error-message">{errors.aggrement_extension_duration}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement End Schedule Date<span className="required">*</span></label>
          <input type="date" name="end_date" min={formData.agreement_date} onChange={handleInputChange} value={formData.end_date} className={errors.end_date ? "error" : inputState.end_date ? "success" : ""} />
          {errors.end_date && <span className="error-message">{errors.end_date}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Bank & Contact <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderBankSection = () => (
    <div className="form-section">
      <div className="section-title">
        <CreditCard size={18} />
        <h4>Bank & Contact</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><User size={14} /> Owner Name<span className="required">*</span></label>
          <input type="text" name="owner_name" placeholder="eg: John Doe" onChange={handleInputChange} value={formData.owner_name} className={errors.owner_name ? "error" : inputState.owner_name ? "success" : ""} />
          {errors.owner_name && <span className="error-message">{errors.owner_name}</span>}
        </div>

        <div className="form-field">
          <label><Building2 size={14} /> Bank Name<span className="required">*</span></label>
          <input type="text" name="bank_name" placeholder="eg: SBI" onChange={handleInputChange} value={formData.bank_name} className={errors.bank_name ? "error" : inputState.bank_name ? "success" : ""} />
          {errors.bank_name && <span className="error-message">{errors.bank_name}</span>}
        </div>

        <div className="form-field">
          <label><User size={14} /> Account Holder Name<span className="required">*</span></label>
          <input type="text" name="account_holder_name" placeholder="eg: John Doe" onChange={handleInputChange} value={formData.account_holder_name} className={errors.account_holder_name ? "error" : inputState.account_holder_name ? "success" : ""} />
          {errors.account_holder_name && <span className="error-message">{errors.account_holder_name}</span>}
        </div>

        <div className="form-field">
          <label><Hash size={14} /> Account Number<span className="required">*</span></label>
          <input type="number" min={0} name="account_num" placeholder="eg: 8224521455625562" onChange={handleInputChange} value={formData.account_num} className={errors.account_num ? "error" : inputState.account_num ? "success" : ""} />
          {errors.account_num && <span className="error-message">{errors.account_num}</span>}
        </div>

        <div className="form-field">
          <label><Hash size={14} /> IFSC Code<span className="required">*</span></label>
          <input type="text" name="ifsc_code" placeholder="eg: SBI0046246" onChange={handleInputChange} value={formData.ifsc_code} className={errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""} />
          {errors.ifsc_code && <span className="error-message">{errors.ifsc_code}</span>}
        </div>

        <div className="form-field">
          <label><CreditCard size={14} /> PAN Card<span className="required">*</span></label>
          <input type="text" name="pan_card" placeholder="eg: DGSPF4145F" onChange={handleInputChange} value={formData.pan_card} className={errors.pan_card ? "error" : inputState.pan_card ? "success" : ""} />
          {errors.pan_card && <span className="error-message">{errors.pan_card}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> GST Number<span className="required">*</span></label>
          <input type="text" name="gst_num" placeholder="eg: GSTIN552466" onChange={handleInputChange} value={formData.gst_num} className={errors.gst_num ? "error" : inputState.gst_num ? "success" : ""} />
          {errors.gst_num && <span className="error-message">{errors.gst_num}</span>}
        </div>

        <div className="form-field">
          <label><Phone size={14} /> Phone Number<span className="required">*</span></label>
          <input type="number" min={0} maxLength={10} name="mobile" placeholder="eg: 8759745268" onChange={handleInputChange} value={formData.mobile} className={errors.mobile ? "error" : inputState.mobile ? "success" : ""} />
          {errors.mobile && <span className="error-message">{errors.mobile}</span>}
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Address<span className="required">*</span></label>
          <input type="text" name="address" placeholder="eg: 15, Delhi Cantt" onChange={handleInputChange} value={formData.address} className={errors.address ? "error" : inputState.address ? "success" : ""} />
          {errors.address && <span className="error-message">{errors.address}</span>}
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous: Agreement Timeline
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Adding...' : 'Add Office Rent'}</span>
          </button>
        </div>
      </div>

      <p className="error-message" style={{ marginTop: '12px' }}>
        {isSubmitted && Object.keys(errors).length > 0 && (
          Object.keys(errors).length > 5 ? (
            <span>Please fill all mandatory fields!</span>
          ) : (
            Object.keys(errors).map((field) => field.charAt(0).toUpperCase() + field.slice(1)).join(', ') + ' are required!'
          )
        )}
      </p>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'office': return renderOfficeSection();
      case 'financials': return renderFinancialsSection();
      case 'timeline': return renderTimelineSection();
      case 'bank': return renderBankSection();
      default: return renderOfficeSection();
    }
  };

  return (
    <>
      <AddDynamicButton title="Add Office Rent" logo={<Building2 size={24} />} onClick={handleShow} />

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <Building2 size={24} />
              </div>
              <div>
                <Modal.Title>Add Office Rent</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to add a new office rent agreement</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <Modal.Body className="modern-modal-body">
            <div className="section-navigation">
              {sections.map((section) => {
                const Icon = section.icon;
                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                return (
                  <button
                    key={section.id}
                    className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                    onClick={() => handleTabSwitch(section.id)}
                  >
                    <Icon size={16} />
                    <span>{section.label}</span>
                    {showWarning && <div className="warning-dot" title="Missing required fields" />}
                    {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                );
              })}
            </div>

            <form onSubmit={handleSubmit} className="project-form">
              {renderCurrentSection()}
            </form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};




const DeleteOfficeRent = ({ i, getRent }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/officerentupdate/${i.id}/`);
      if (res.status === 200) {
        await getRent();
        toast.dismiss(loadingToastId);
        toast.success("Data deleted successfully!");
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Office Rent" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete Office Rent</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete the office rent record for <strong>{i.account_holder_name}</strong>?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleFormSubmitDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const UpdateOfficeRent = ({ getRent, projectId, siteProjectList, i, subcompanyId }) => {
  const [show, setShow] = useState(false);
  const projectID = sessionStorage.getItem("sitemanagement_project_site_prcode");
  const [project, setProject] = useState(projectID ? projectID : "null");
  const [activeSection, setActiveSection] = useState('office');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'office', label: 'Office & Project', icon: Building2 },
    { id: 'financials', label: 'Financials', icon: IndianRupee },
    { id: 'timeline', label: 'Agreement Timeline', icon: Calendar },
    { id: 'bank', label: 'Bank & Contact', icon: CreditCard },
  ];

  const tabRequiredFields = {
    office: ["project", "office_type", "BOQOfficeRent"],
    financials: ["rent_amt"],
    timeline: ["agreement_duration", "agreement_date", "end_date"],
    bank: ["owner_name", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "address", "mobile"],
  };

  const handleClose = () => {
    setShow(false);
    setErrors({});
    setTabValidationAttempted({});
    setActiveSection('office');
  };

  const handleShow = () => {
    setShow(true);
    getproject();
    const filteredData = { ...i };
    delete filteredData.agreement_upload;
    setFormData(filteredData);
    setProject(i.project);
    setErrors({});
    setTabValidationAttempted({});
    setActiveSection('office');
  };

  const [formData, setFormData] = useState({
    project: projectID ? projectID : "",
    rent_amt: "",
    agreement_duration: "",
    agreement_date: "",
    end_date: null,
    owner_name: "",
    bank_name: "",
    account_holder_name: "",
    account_num: "",
    ifsc_code: "",
    pan_card: "",
    gst_num: "",
    address: "",
    aggrement_extension_duration: "0",
    office_type: "",
    mobile: "",
    BOQOfficeRent: '',
    total_amt: '',
  });

  const [boqList, setBoqList] = useState([]);
  const [loadingboq, setLoadingboq] = useState(false);

  const getBoq = async () => {
    try {
      const ress = await axios.get(`${BASE_URL}/siteproject/boqofficerentfilters/${formData.project}/`);
      setBoqList(ress.data);
      setLoadingboq(true);
    } catch (err) { }
  };

  useEffect(() => {
    if (formData.project != "") getBoq();
  }, [formData.project]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["project", "rent_amt", 'office_type', "agreement_duration", "agreement_date", "owner_name", "bank_name", "account_holder_name", "account_num", "ifsc_code", "pan_card", "address", "mobile", "end_date",];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });
    if (formData.office_type === "Site Office" && !formData.BOQOfficeRent) {
      newErrors.BOQOfficeRent = "This is required field!";
    }
    if (formData.project === "null") {
      newErrors.project = "This is required field!";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const newErrors = {};
    let fieldsToValidate = [...(tabRequiredFields[currentTab] || [])];

    // BOQOfficeRent only applies when office_type === "Site Office"
    if (currentTab === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }

    fieldsToValidate.forEach((field) => {
      if (!formData[field] || formData[field] === "null") {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors((prev) => {
      const updated = { ...prev, ...newErrors };
      fieldsToValidate.forEach((field) => {
        if (!(field in newErrors)) delete updated[field];
      });
      return updated;
    });

    setTabValidationAttempted((prev) => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  const hasCurrentTabErrors = () => {
    const currentTab = activeSection;
    const fieldsToValidate = tabRequiredFields[currentTab] || [];
    return fieldsToValidate.some((field) => errors[field]);
  };

  const getCurrentTabErrorMessage = () => {
    const currentTab = activeSection;
    let fieldsToValidate = [...(tabRequiredFields[currentTab] || [])];
    if (currentTab === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }
    const missingFields = fieldsToValidate
      .filter((field) => !formData[field] || formData[field] === "null")
      .map((field) => field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' '));

    if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
    if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
    if (missingFields.length > 1) return `Please fill all required fields in ${sections.find(s => s.id === currentTab)?.label} before proceeding`;
    return `Please fix the errors in this section before proceeding`;
  };

  const tabHasMissingFields = (tabId) => {
    let fieldsToValidate = [...(tabRequiredFields[tabId] || [])];
    if (tabId === "office" && formData.office_type !== "Site Office") {
      fieldsToValidate = fieldsToValidate.filter(f => f !== "BOQOfficeRent");
    }
    return fieldsToValidate.some((field) => !formData[field] || formData[field] === "null");
  };

  const [loading, setLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  const getproject = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/project/`);
      const splitCodeParts = (code) => {
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/");
        const lastPart = parts.pop();
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
        if (match) {
          return { firstPart, numericPart: match[1] ? parseInt(match[1], 10) : 0, alphaPart: match[2] };
        }
        return { firstPart, numericPart: 0, alphaPart: "" };
      };
      const sortedList = response.data.sort((a, b) => {
        const aParts = splitCodeParts(a.site_prcode);
        const bParts = splitCodeParts(b.site_prcode);
        if (aParts.firstPart !== bParts.firstPart) return aParts.firstPart.localeCompare(bParts.firstPart);
        if (aParts.alphaPart !== bParts.alphaPart) return aParts.alphaPart.localeCompare(bParts.alphaPart);
        return aParts.numericPart - bParts.numericPart;
      });
      setProjectList(sortedList);
    } catch (error) {
      alert(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    const formDataa = new FormData();
    const updatedfromdata = { ...formData };
    Object.keys(updatedfromdata).forEach((key) => {
      if (updatedfromdata[key] && key !== "agreement_upload") {
        formDataa.append(key, updatedfromdata[key]);
      }
    });
    if (updatedfromdata.agreement_upload) {
      formDataa.append("agreement_upload", updatedfromdata.agreement_upload);
    }

    try {
      let res = await axios.put(`${BASE_URL}/siteproject/officerentupdate/${i.id}/`, formDataa, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 200) {
        await getRent();
        toast.dismiss(loadingToastId);
        toast.success("Office Rent Updated Successfully!");
        handleClose();
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to update office rent!");
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...formData, [name]: value };

    if (name === "rent_amt") {
      const rentAmount = parseFloat(value).toFixed(2);
      const boqItem = boqList.find((attendance) => attendance.id === formData.BOQOfficeRent);

      if (boqItem) {
        const maxlimit = boqItem.rate_per_month;
        const { success, error } = inputMaxLimit(name, value, maxlimit);
        if (!success) {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
          return;
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
          if (rentAmount >= 50000) {
            const tdsPercentage = 10;
            const tdsAmount = parseFloat(((rentAmount * tdsPercentage) / 100).toFixed(2));
            updatedData = { ...updatedData, tds_percentage: tdsPercentage, tds_amt: tdsAmount, total_amt: parseFloat((parseFloat(rentAmount) - tdsAmount).toFixed(2)) };
          } else {
            updatedData = { ...updatedData, tds_percentage: "", tds_amt: 0, total_amt: parseFloat(rentAmount) };
          }
        }
      } else {
        if (rentAmount >= 50000) {
          const tdsPercentage = 10;
          const tdsAmount = parseFloat(((rentAmount * tdsPercentage) / 100).toFixed(2));
          updatedData = { ...updatedData, tds_percentage: tdsPercentage, tds_amt: tdsAmount, total_amt: parseFloat((parseFloat(rentAmount) - tdsAmount).toFixed(2)) };
        } else {
          updatedData = { ...updatedData, tds_percentage: "", tds_amt: 0, total_amt: parseFloat(rentAmount) };
        }
      }
    }

    if (name === "tds_percentage" && Number(formData.rent_amt) >= 50000) {
      const tdsPercentage = parseFloat(value).toFixed(2);
      const tdsAmount = parseFloat(((Number(formData.rent_amt) * tdsPercentage) / 100).toFixed(2));
      updatedData = { ...updatedData, tds_amt: tdsAmount, total_amt: parseFloat((Number(formData.rent_amt) - tdsAmount).toFixed(2)) };
    }

    setFormData(updatedData);
    setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });

    if (errors[name]) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (file) {
      const validFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
      if (validFileTypes.includes(file.type)) {
        setFormData({ ...formData, [name]: file });
        setErrors({ ...errors, [name]: "" });
      } else {
        setErrors({ ...errors, [name]: "Invalid file type. Please select a PDF or DOC file." });
      }
    } else {
      setFormData({ ...formData, [name]: null });
    }
  };

  const rentOption = [
    { value: "Site Office", label: "Site Office" },
    { value: "Guest House", label: "Guest House" },
  ];

  useEffect(() => {
    const { agreement_duration, aggrement_extension_duration, agreement_date } = formData;
    const durations = agreement_duration && aggrement_extension_duration ? Number(agreement_duration) + Number(aggrement_extension_duration) : "";
    const addMonthsToDate = (dateString, months) => {
      if (!dateString || !months) return "";
      const date = new Date(dateString);
      date.setMonth(date.getMonth() + Number(months));
      return date.toISOString().split("T")[0];
    };
    const endDate = addMonthsToDate(agreement_date, durations);
    setFormData((prev) => ({ ...prev, end_date: endDate }));
  }, [formData.agreement_date, formData.agreement_duration, formData.aggrement_extension_duration]);

  const handleTabSwitch = (targetTabId) => {
    if (activeSection === targetTabId) return;
    if (validateCurrentTab()) {
      setActiveSection(targetTabId);
      const modalBody = document.querySelector('.modern-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    } else {
      const modalBody = document.querySelector('.modern-modal-body');
      if (modalBody) modalBody.scrollTop = 0;
    }
  };

  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;
    if (!nextTab) return;
    handleTabSwitch(nextTab);
  };
  const goToPreviousTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    if (currentIndex > 0) setActiveSection(sections[currentIndex - 1].id);
  };

  const renderOfficeSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Building2 size={18} />
        <h4>Office & Project</h4>
      </div>
      <div className="form-grid">
        {sessionStorage.getItem('sitemanagement_role') !== "SiteManagement" && (
          <div className="form-field">
            <Projects inputvalue="project" usedFor="form" toggleProject={project} setToggleProject={setProject} value="id" subcompany={subcompanyId} error={errors.project} SetErrors={setErrors} cssType="modern" />
            {errors.project && <span className="error-message">{errors.project}</span>}
          </div>
        )}

        <div className="form-field">
          <label><Home size={14} /> Office Type<span className="required">*</span></label>
          <Select
            options={rentOption}
            isSearchable isClearable
            placeholder="Select Office Type"
            value={rentOption.find((opt) => opt.value === formData.office_type)}
            onChange={(selectedOption) => {
              setFormData({ ...formData, office_type: selectedOption ? selectedOption.value : "" });
              setInputState({ ...inputState, office_type: selectedOption ? "green" : "" });
            }}
            styles={CSSForSelectModern}
          />
          {errors.office_type && <span className="error-message">{errors.office_type}</span>}
        </div>

        {(formData.project !== "null" && formData.office_type === "Site Office") && (
          <div className="form-field">
            <label><IndianRupee size={14} /> BOQ Rate<span className="required">*</span></label>
            {!loadingboq ? (
              <div className="loader-minimal" style={{ padding: '10px 0' }}>
                <div className="spinner-minimal"></div>
              </div>
            ) : (
              <select
                name="BOQOfficeRent"
                value={formData.BOQOfficeRent}
                onChange={handleInputChange}
                className={errors.BOQOfficeRent ? "error" : inputState.BOQOfficeRent ? "success" : ""}
              >
                <option value="">Select a Boq</option>
                {boqList?.sort((a, b) => a?.rate_per_month?.toString().localeCompare(b?.rate_per_month?.toString(), 'en', { ignorePunctuation: true })).map((b, index) => (
                  <option key={index} value={b.id}>₹{formatCurrencyIndian(b.rate_per_month)}</option>
                ))}
              </select>
            )}
            {errors.BOQOfficeRent && <span className="error-message">{errors.BOQOfficeRent}</span>}
          </div>
        )}
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Financials <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderFinancialsSection = () => (
    <div className="form-section">
      <div className="section-title">
        <IndianRupee size={18} />
        <h4>Financials</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><IndianRupee size={14} /> Basic Amount<span className="required">*</span></label>
          <input type="number" min={0} name="rent_amt" placeholder="80,000" onChange={handleInputChange} value={formData.rent_amt} className={errors.rent_amt ? "error" : inputState.rent_amt ? "success" : ""} />
          {errors.rent_amt && <span className="error-message">{errors.rent_amt}</span>}
        </div>

        {Number(formData.rent_amt) >= 50000 && (
          <>
            <div className="form-field">
              <label><IndianRupee size={14} /> TDS Percentage<span className="required">*</span></label>
              <input type="number" min={0} name="tds_percentage" placeholder="TDS Percentage" onChange={handleInputChange} value={formData.tds_percentage} className={errors.tds_percentage ? "error" : inputState.tds_percentage ? "success" : ""} />
              {errors.tds_percentage && <span className="error-message">{errors.tds_percentage}</span>}
            </div>
            <div className="form-field">
              <label><IndianRupee size={14} /> TDS Amount<span className="required">(Read Only)</span></label>
              <input type="number" min={0} name="tds_amt" placeholder="TDS Amount" value={formData.tds_amt} disabled readOnly className="readonly-field" />
            </div>
          </>
        )}

        <div className="form-field">
          <label><IndianRupee size={14} /> Total Amount<span className="required">(Auto Calculated)</span></label>
          <input type="number" min={0} name="total_amt" placeholder="80,000" value={formData.total_amt} disabled readOnly className="readonly-field" />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Agreement Timeline <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderTimelineSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Calendar size={18} />
        <h4>Agreement Timeline</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Clock size={14} /> Agreement Duration<span className="required">*</span></label>
          <input type="number" min={0} name="agreement_duration" placeholder="6 months" onChange={handleInputChange} value={formData.agreement_duration} className={errors.agreement_duration ? "error" : inputState.agreement_duration ? "success" : ""} />
          {errors.agreement_duration && <span className="error-message">{errors.agreement_duration}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement Date<span className="required">*</span></label>
          <input type="date" name="agreement_date" onChange={handleInputChange} value={formData.agreement_date} className={errors.agreement_date ? "error" : inputState.agreement_date ? "success" : ""} />
          {errors.agreement_date && <span className="error-message">{errors.agreement_date}</span>}
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Agreement Extension Duration</label>
          <input type="number" min={0} name="aggrement_extension_duration" placeholder="6 months" onChange={handleInputChange} value={formData.aggrement_extension_duration} className={errors.aggrement_extension_duration ? "error" : inputState.aggrement_extension_duration ? "success" : ""} />
          {errors.aggrement_extension_duration && <span className="error-message">{errors.aggrement_extension_duration}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement End Schedule Date<span className="required">*</span></label>
          <input type="date" name="end_date" min={formData.agreement_date} onChange={handleInputChange} value={formData.end_date} className={errors.end_date ? "error" : inputState.end_date ? "success" : ""} />
          {errors.end_date && <span className="error-message">{errors.end_date}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Bank & Contact <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderBankSection = () => (
    <div className="form-section">
      <div className="section-title">
        <CreditCard size={18} />
        <h4>Bank & Contact</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><User size={14} /> Owner Name<span className="required">*</span></label>
          <input type="text" name="owner_name" placeholder="eg: John Doe" onChange={handleInputChange} value={formData.owner_name} className={errors.owner_name ? "error" : inputState.owner_name ? "success" : ""} />
          {errors.owner_name && <span className="error-message">{errors.owner_name}</span>}
        </div>

        <div className="form-field">
          <label><Building2 size={14} /> Bank Name<span className="required">*</span></label>
          <input type="text" name="bank_name" placeholder="eg: SBI" onChange={handleInputChange} value={formData.bank_name} className={errors.bank_name ? "error" : inputState.bank_name ? "success" : ""} />
          {errors.bank_name && <span className="error-message">{errors.bank_name}</span>}
        </div>

        <div className="form-field">
          <label><User size={14} /> Account Holder Name<span className="required">*</span></label>
          <input type="text" name="account_holder_name" placeholder="eg: John Doe" onChange={handleInputChange} value={formData.account_holder_name} className={errors.account_holder_name ? "error" : inputState.account_holder_name ? "success" : ""} />
          {errors.account_holder_name && <span className="error-message">{errors.account_holder_name}</span>}
        </div>

        <div className="form-field">
          <label><Hash size={14} /> Account Number<span className="required">*</span></label>
          <input type="number" min={0} name="account_num" placeholder="eg: 8224521455625562" onChange={handleInputChange} value={formData.account_num} className={errors.account_num ? "error" : inputState.account_num ? "success" : ""} />
          {errors.account_num && <span className="error-message">{errors.account_num}</span>}
        </div>

        <div className="form-field">
          <label><Hash size={14} /> IFSC Code<span className="required">*</span></label>
          <input type="text" name="ifsc_code" placeholder="eg: SBI0046246" onChange={handleInputChange} value={formData.ifsc_code} className={errors.ifsc_code ? "error" : inputState.ifsc_code ? "success" : ""} />
          {errors.ifsc_code && <span className="error-message">{errors.ifsc_code}</span>}
        </div>

        <div className="form-field">
          <label><CreditCard size={14} /> PAN Card<span className="required">*</span></label>
          <input type="text" name="pan_card" placeholder="eg: DGSPF4145F" onChange={handleInputChange} value={formData.pan_card} className={errors.pan_card ? "error" : inputState.pan_card ? "success" : ""} />
          {errors.pan_card && <span className="error-message">{errors.pan_card}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> GST Number</label>
          <input type="text" name="gst_num" placeholder="eg: GSTIN552466" onChange={handleInputChange} value={formData.gst_num} className={errors.gst_num ? "error" : inputState.gst_num ? "success" : ""} />
          {errors.gst_num && <span className="error-message">{errors.gst_num}</span>}
        </div>

        <div className="form-field">
          <label><Phone size={14} /> Phone Number<span className="required">*</span></label>
          <input type="number" min={0} maxLength={10} name="mobile" placeholder="eg: 8759745268" onChange={handleInputChange} value={formData.mobile} className={errors.mobile ? "error" : inputState.mobile ? "success" : ""} />
          {errors.mobile && <span className="error-message">{errors.mobile}</span>}
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Address<span className="required">*</span></label>
          <input type="text" name="address" placeholder="eg: 15, Delhi Cantt" onChange={handleInputChange} value={formData.address} className={errors.address ? "error" : inputState.address ? "success" : ""} />
          {errors.address && <span className="error-message">{errors.address}</span>}
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous: Agreement Timeline
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="button" className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Updating...' : 'Update'}</span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'office': return renderOfficeSection();
      case 'financials': return renderFinancialsSection();
      case 'timeline': return renderTimelineSection();
      case 'bank': return renderBankSection();
      default: return renderOfficeSection();
    }
  };

  return (
    <>
      <button title="Update Office Rent" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <UpdatePencil modernButton='true' />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <Building2 size={24} />
              </div>
              <div>
                <Modal.Title>Update Office Rent</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Edit office rent agreement details</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <Modal.Body className="modern-modal-body">
            <div className="section-navigation">
              {sections.map((section) => {
                const Icon = section.icon;
                const showWarning = tabValidationAttempted[activeSection] && tabHasMissingFields(section.id) && section.id !== activeSection;
                return (
                  <button
                    key={section.id}
                    className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${showWarning ? 'has-warning' : ''}`}
                    onClick={() => handleTabSwitch(section.id)}
                  >
                    <Icon size={16} />
                    <span>{section.label}</span>
                    {showWarning && <div className="warning-dot" title="Missing required fields" />}
                    {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                );
              })}
            </div>

            <form onSubmit={handleSubmit} className="project-form">
              {renderCurrentSection()}
            </form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};



const OfficeRent = (i) => {
  const [project, setProject] = useState("null");
  const [buffer, setBuffering] = useState(false);
  const [subCompanyList, setSubCompanyList] = useState([]);
  const [subCompany, setSubCompany] = useState("null");
  const [projectList, setProjectList] = useState([]);
  const { projectID } = usePermission();
  const [selectedName, setName] = useState("");
  const [selectedFromDate, setFromDate] = useState('null');
  const [selectedToDate, setToDate] = useState('null');
  const [officeRentList, setOfficeRentList] = useState([]);
  const role = sessionStorage.getItem('sitemanagement_role');
  const [showFilters, setShowFilters] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);
  const tableRef = useRef(null);

  useEffect(() => {
    getSubCompany();
    getRent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectID, project]);

  useEffect(() => {
    getproject();
  }, [subCompany]);

  const getRent = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/officerentbyproj/${projectID ? projectID : project}/`);
      setOfficeRentList(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const getproject = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${subCompany}/`);
      const splitCodeParts = (code) => {
        const parts = code.trim().split("/");
        const firstPart = parts.slice(0, -1).join("/");
        const lastPart = parts.pop();
        const match = lastPart.match(/^(\d+)?([A-Za-z]+)$/);
        if (match) {
          return { firstPart, numericPart: match[1] ? parseInt(match[1], 10) : 0, alphaPart: match[2] };
        }
        return { firstPart, numericPart: 0, alphaPart: "" };
      };
      const sortedList = response.data.sort((a, b) => {
        const aParts = splitCodeParts(a.site_prcode);
        const bParts = splitCodeParts(b.site_prcode);
        if (aParts.firstPart !== bParts.firstPart) return aParts.firstPart.localeCompare(bParts.firstPart);
        if (aParts.alphaPart !== bParts.alphaPart) return aParts.alphaPart.localeCompare(bParts.alphaPart);
        return aParts.numericPart - bParts.numericPart;
      });
      setProjectList(sortedList);
    } catch (error) {
      alert(error);
    }
  };

  const getSubCompany = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSubCompanyList(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const filterByOwnerNameAndDate = () => {
    return officeRentList.filter((item) => {
      const matchesName = selectedName ? item.owner_name.toLowerCase().includes(selectedName.toLowerCase()) : true;
      const itemDate = Date.parse(item.agreement_date);
      const fromDate = selectedFromDate !== 'null' ? Date.parse(selectedFromDate) : null;
      const toDate = selectedToDate !== 'null' ? Date.parse(selectedToDate) : null;
      const matchesFromDate = fromDate ? itemDate >= fromDate : true;
      const matchesToDate = toDate ? itemDate <= toDate : true;
      return matchesName && matchesFromDate && matchesToDate;
    });
  };

  const filteredData = filterByOwnerNameAndDate();

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const showFilterBar = !projectID;
  const hasActiveFilters = subCompany !== "null" || project !== "null" || selectedName !== "" || selectedFromDate !== "null" || selectedToDate !== "null";

  const clearAllFilters = () => {
    setSubCompany("null");
    setProject("null");
    setName("");
    setFromDate("null");
    setToDate("null");
  };

  const canUpdate = (item) => (["SiteManagement", "Checker"].includes(role) && !isMoreThan24Hours(item.created_at)) || !["SiteManagement", "Checker"].includes(role);
  const canDelete = () => !["SiteManagement", "Checker"].includes(role);

  return (
    <div className="progress-modern-container">

      {showFilters && (
        <div className="filter-bar-attractive">
          <div className="filter-group-attractive">
            {showFilterBar && (
              <>
                <div className={`filter-chip ${subCompany !== "null" ? "active" : ""}`} style={{ padding: '0px' }}>
                  <div className="filter-chip-content">
                    <SubCompanyModern toggleCompany={subCompany} setToggleCompany={setSubCompany} cssType="modern" />
                  </div>
                </div>

                <div className={`filter-chip ${project !== "null" ? "active" : ""}`} style={{ paddingTop: '0px', paddingBottom: "0px" }}>
                  <div className="filter-chip-content">
                    <Projects usedFor="filter" value="id" toggleProject={project} subcompany={subCompany} setToggleProject={setProject} />
                  </div>
                </div>
              </>
            )}

            <div className="filter-chip" style={{ minWidth: '200px' }}>
              <div className="subcompany-selectorssss-content" style={{ width: '100%' }}>
                <User size={16} className="selector-iconss" />
                <input
                  className="modern-select"
                  style={{ width: '100%' }}
                  placeholder="Owner Name"
                  value={selectedName}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>

            <div className="filter-chip" style={{ paddingTop: '0px', paddingBottom: "0px", background: "transparent", border: "none" }}>
              <div className="filter-chip-content">
                <DateRangePicker
                  startDate={selectedFromDate}
                  endDate={selectedToDate}
                  placeHolder1="From Date"
                  placeHolder2="To Date"
                  onChange={(start, end) => {
                    setFromDate(start);
                    setToDate(end);
                  }}
                />
              </div>
            </div>

            {hasActiveFilters && role === "Admin" && (
              <button className="clear-filters-btn" onClick={clearAllFilters}>
                <X size={13} />
                Clear
              </button>
            )}
          </div>
        </div>
      )}

      {/* Stats + toggle + actions */}
      <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="stats-minimal-row">
          <div className="stat-minimal-item">
            <Building2 size={14} />
            <span>Showing</span>
            <strong>{filteredData.length} records</strong>
          </div>
        </div>

        <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
          <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
            <Filter size={14} />
            <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
            {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </button>

          {role !== "ViewAccess" && (
            <div className="filter-actions-attractive" style={{ display: 'flex', gap: '8px' }}>
              <AddOfficeRent getRent={getRent} subcompanyId={subCompany} />
              <UploadOfficeRentBulk getOfficeRent={getRent} />
            </div>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper-minimal table-box scroll-container-table">
        {buffer ? (
          <div className="loader-minimal">
            <div className="spinner-minimal"></div>
          </div>
        ) : (
          <table className="progress-table-minimal" ref={tableRef}>
            <thead className="table-heading">
              <tr>
                <th className="col-sno" style={{ width: '5%' }}>#</th>
                <th className="col-period" style={{ width: '18%' }}>Project</th>
                <th className="col-period text-center">Owner / Office Type/Documents</th>
                <th className="col-submitted text-center" style={{ width: '15%' }}>Basic Amount</th>
                <th className="col-approved text-center" style={{ width: '15%' }}>Total Amount</th>
                <th className="col-status text-center" style={{ width: '13%' }}>Agreement</th>
                {role !== "SiteManagement" && role !== "ViewAccess" && <th className="col-action text-center" style={{ width: '15%' }}>Action</th>}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => {
                const isExpanded = expandedRow === index;

                return (
                  <React.Fragment key={index}>
                    <tr className="progress-row">
                      <td className="col-sno text-start">{index + 1}.</td>
                      <td className="col-period">
                        {item.project_code}<br />{item.project_short_name}
                      </td>
                      <td className="col-period">
                        <button className="period-trigger" style={{ width: "100%" }} onClick={() => toggleRow(index)}>
                          <Home size={12} />
                          <span>{item.owner_name}</span>
                          {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                        </button>
                        <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '4px', paddingLeft: '4px' }}>
                          {item.office_type || "-"}
                        </div>
                      </td>
                      <td className="col-submitted text-center">
                        <span className="badge-value">{item.rent_amt ? `₹${formatCurrencyIndian(item.rent_amt)}` : "-"}</span>
                      </td>
                      <td className="col-approved text-center">
                        <span className="badge-value">{item.total_amt ? `₹${formatCurrencyIndian(item.total_amt)}` : "-"}</span>
                      </td>
                      <td className="col-status text-center">
                        <span className="badge-value">{item.agreement_date || "-"}</span>
                      </td>
                      {role !== "SiteManagement" && role !== "ViewAccess" && (
                        <td className="col-action">
                          <div className="action-group-minimal" style={{ justifyContent: 'center', alignItems: 'center' }}>
                            {canUpdate(item) && (
                              <UpdateOfficeRent i={item} getRent={getRent} subcompanyId={subCompany} />
                            )}
                            {canDelete() && (
                              <DeleteOfficeRent i={item} getRent={getRent} />
                            )}
                            {["SiteManagement", "Checker"].includes(role) && isMoreThan24Hours(item.created_at) && (
                              <div style={{ fontSize: "9px", color: "#ef4444", marginTop: "3px", textAlign: 'center' }}>
                                Update window expired
                              </div>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>

                    {isExpanded && (
                      <tr className="expanded-row">
                        <td colSpan={role !== "SiteManagement" && role !== "ViewAccess" ? 7 : 6}>
                          <div className="expanded-content-attractive">
                            <div className="expanded-content-header">
                              <div className="expanded-content-title">
                                <Sparkles size={13} />
                                <span>Full Details</span>
                              </div>
                            </div>

                            <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                              <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                <div className="stage-header">
                                  <IndianRupee size={14} />
                                  <span>Rent & TDS</span>
                                </div>
                                <div className="stage-content">
                                  <div className="stage-row"><span className="stage-label">TDS %</span><span className="amount">{item.tds_percentage ? `${item.tds_percentage}%` : "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">TDS Amount</span><span className="amount">{item.tds_amt ? `₹${formatCurrencyIndian(item.tds_amt)}` : "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">GST No.</span><span className="amount">{item.gst_num || "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">PAN No.</span><span className="amount">{item.pan_card || "-"}</span></div>
                                </div>
                              </div>

                              <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                <div className="stage-header">
                                  <Calendar size={14} />
                                  <span>Agreement</span>
                                </div>
                                <div className="stage-content">
                                  <div className="stage-row"><span className="stage-label">Duration</span><span className="amount">{item.agreement_duration || "-"} months</span></div>
                                  <div className="stage-row"><span className="stage-label">Extension</span><span className="amount">{item.aggrement_extension_duration || "-"} months</span></div>
                                  <div className="stage-row"><span className="stage-label">End Date</span><span className="amount">{item.end_date || "-"}</span></div>
                                </div>
                              </div>

                              <div className="stage-card approved" style={{ flex: 1, minWidth: '240px' }}>
                                <div className="stage-header">
                                  <Landmark size={14} />
                                  <span>Bank Details</span>
                                </div>
                                <div className="stage-content">
                                  <div className="stage-row"><span className="stage-label">Bank Name</span><span className="amount">{item.bank_name || "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">Holder Name</span><span className="amount">{item.account_holder_name || "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">Account No.</span><span className="amount">{item.account_num || "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">IFSC Code</span><span className="amount">{item.ifsc_code || "-"}</span></div>
                                </div>
                              </div>

                              <div className="stage-card" style={{ flex: 1, minWidth: '240px', background: 'white' }}>
                                <div className="stage-header">
                                  <Phone size={14} />
                                  <span>Contact & Address</span>
                                </div>
                                <div className="stage-content">
                                  <div className="stage-row"><span className="stage-label">Mobile No.</span><span className="amount">{item.mobile || "-"}</span></div>
                                  <div className="stage-row"><span className="stage-label">Address</span><span className="amount">{item.address || "-"}</span></div>
                                </div>
                              </div>
                            </div>

                            <div style={{ marginTop: '14px' }}>
                              <DocumentModel officerent={item.id} title={"Office Rent Document"} rentData={officeRentList} getDocument={getRent} />
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              {filteredData.length === 0 && (
                <tr>
                  <td colSpan={role !== "SiteManagement" && role !== "ViewAccess" ? 7 : 6}>
                    <div className="empty-state-attractive">
                      <div className="empty-state-icon-wrap">
                        <Home size={32} />
                      </div>
                      <h4 className="empty-state-title">No Office Rent Records Found</h4>
                      <p className="empty-state-subtitle">
                        Try adjusting your filters to view records.
                      </p>
                      {hasActiveFilters && role === "Admin" && (
                        <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                          <X size={13} />
                          Clear Filters
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};


export default OfficeRent;